import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INotification, INotificationsState } from '../../types/notifications';

export const initialNotificationsState: INotificationsState = {
  list: [],
};

const notificationsSlice = createSlice({
  initialState: initialNotificationsState,
  name: 'notifications',
  reducers: {
    addNotification: (state, action: PayloadAction<INotification>) => {
      state.list.push(action.payload);
    },
    clearNotifications: state => {
      state.list = [];
    },
  },
  selectors: {
    selectNotifications: state => state.list,
  },
});

export const {
  reducer: notificationsReducer,
  actions: { addNotification, clearNotifications },
  selectors: { selectNotifications },
} = notificationsSlice;
